'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_GroceryItemSearch(text, pageIndex, pageSize, sort) {
  this.z9 = null;
  this.z7 = 0;
  this.z8 = 0;
  this.Lr = null;
  this.z9 = text;
  this.z7 = pageIndex;
  this.z8 = pageSize;
  this.Lr = sort;
}
export { $c_Lmealorama_GroceryItemSearch as $c_Lmealorama_GroceryItemSearch };
$p = $c_Lmealorama_GroceryItemSearch.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_GroceryItemSearch;
/** @constructor */
function $h_Lmealorama_GroceryItemSearch() {
}
export { $h_Lmealorama_GroceryItemSearch as $h_Lmealorama_GroceryItemSearch };
$h_Lmealorama_GroceryItemSearch.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, (-183506072));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.z9));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, this.z7);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, this.z8);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.Lr));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().ax(acc, 4);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_GroceryItemSearch)) {
    if ((((this.z7 === x$0.z7) && (this.z8 === x$0.z8)) && (this.z9 === x$0.z9))) {
      var x = this.Lr;
      var x$2 = x$0.Lr;
      return ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 4;
});
$p.r = (function() {
  return "GroceryItemSearch";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.z9;
      break;
    }
    case 1: {
      return this.z7;
      break;
    }
    case 2: {
      return this.z8;
      break;
    }
    case 3: {
      return this.Lr;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Lmealorama_GroceryItemSearch(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jx)));
}
export { $isArrayOf_Lmealorama_GroceryItemSearch as $isArrayOf_Lmealorama_GroceryItemSearch };
var $d_Lmealorama_GroceryItemSearch = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_GroceryItemSearch, "mealorama.GroceryItemSearch", ({
  jx: 1,
  bB: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_GroceryItemSearch as $d_Lmealorama_GroceryItemSearch };
//# sourceMappingURL=mealorama.-Grocery-Item-Search.js.map
